import { Model } from 'modules/core/lib/mobx-rest'

export interface IChargebeeSubscription {
  [key: string]: any
}

class ChargebeeSubscription extends Model<IChargebeeSubscription> {
  static urlRoot() {
    return '/billing/chargebee_subscriptions'
  }
}

export default ChargebeeSubscription
